import { render, staticRenderFns } from "./TripleTable.vue?vue&type=template&id=88f43938"
import script from "./TripleTable.vue?vue&type=script&lang=js"
export * from "./TripleTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports